import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ItemFilterEntity } from '../../domain/entities/ItemsFilterEntity'

export class ItemFilterModel extends ItemFilterEntity {
  categoryId?: number
  branchId?: number
  venderId?: number
  createdAtFrom?: string
  createdAtTo?: string

  constructor(dataDto: ItemFilterEntity) {
    super()
    mapEntityProperties<ItemFilterModel>(this, dataDto, {
      exclude: ['branch', 'category', 'vender' , 'date'],
      map: {
        categoryId: dataDto.category?.id,
        branchId: dataDto.branch?.id,
        venderId: dataDto.vender?.id,
        createdAtFrom: dataDto.date ? dataDto.date[0] : undefined,
        createdAtTo: dataDto.date ? dataDto.date[1] : undefined,
      }
    })
  }
}
